module.exports = __webpack_public_path__ + "static/media/bears_hot_coffee.0a5bcd0d.jpg";